import LottieGraphic from './LottieGraphic';
import AnimatedCheckmarkJSON from './lottie/animated-checkmark.json';

export function AnimatedCheckmarkGraphic({ onComplete }: { onComplete?: () => void }) {
    return (
        <LottieGraphic
            startPlay
            className="animated-checkmark-graphic"
            json={AnimatedCheckmarkJSON}
            speed={0.75}
            onComplete={onComplete}
        />
    );
}
